// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610200935/js/" + chunkId + "." + {"44":"53c0bd89","225":"919561fa","481":"13950949","486":"986452e0","770":"8f6d1ab5"}[chunkId] + ".0.023699048616825258.chunk.js";
};